import Swiper from './../../node_modules/swiper';
import { Navigation, Autoplay } from 'swiper/modules';

const contentDiv = document.querySelectorAll(
	'.industries-content .industries-inner-div',
);
let currentActive;

const industySwiper = new Swiper('.industries-slider', {
	slidesPerView: 1,
	modules: [Navigation, Autoplay],
	on: {
		init: function () {
			currentActive = contentDiv[0];
			currentActive.classList.add('active');
		},
	},
	autoplay: {
		delay: 2000,
		disableOnInteraction: false,
	},
	navigation: {
		nextEl: '.industy-wrapper .swiper-button-next',
		prevEl: '.industy-wrapper .swiper-button-prev',
	},
});

industySwiper.on('slideChange', (e) => {
	currentActive.classList.remove('active');
	currentActive = contentDiv[e.activeIndex];
	currentActive.classList.add('active');
});
